import React, { useState } from "react";
import { API_URL } from "../constants";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Toast from "./Toast";

export default function SetDefaultEmailFrequency({ token, motor }) {
  const [defaultEmailFrequency, setDefaultEmailFrequency] = useState(
    motor && motor.frequenceRelance !== undefined ? String(motor.frequenceRelance) : "0"
  );
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState({ type: '', message: '' });

  const showToast = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast({ type: '', message: '' }), 3000);
  };

  const handleFrequencyChange = (e) => {
    setDefaultEmailFrequency(e.target.value);
  };

  const handleSetFrequency = async () => {
    setSubmitting(true);
    try {
      const response = await axios.put(
        `${API_URL}/camera/relance`,
        {
          id_camera: motor.id,
          frequenceRelance: defaultEmailFrequency,
        },
        {
          headers: {
            mode: "cors",
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );

      if (response.status === 200) {
        showToast('success', 'Fréquence mise à jour avec succès !');
      } else {
        console.error(
          "Erreur lors de la mise à jour de la fréquence d'envoi d'e-mails"
        );
        showToast('error', "Échec de la mise à jour.");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        alert(
          "ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer."
        );
        localStorage.clear();
        navigate("/login");
        return;
      }
      console.error(error);
      showToast('error', "Échec de la mise à jour.");
    } finally {
      setSubmitting(false);
    }
  };

  const options = [
    { value: "0", label: "Tous les jours" },
    { value: "7", label: "Toutes les semaines" },
    { value: "14", label: "Toutes les deux semaines" },
    { value: "30", label: "Tous les mois" },
  ];

  return (
    <div className="bg-gray-50 rounded-xl p-6">
      <label className="block text-sm font-medium text-gray-600 mb-3">
        Fréquence de relance par e-mail
      </label>
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
        <select
          className="flex-1 border border-gray-300 rounded-lg px-4 py-3 bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 text-gray-700"
          onChange={handleFrequencyChange}
          value={defaultEmailFrequency}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <button
          className="bg-gradient-to-r from-purple-500 to-indigo-500 text-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 font-medium disabled:opacity-50 whitespace-nowrap"
          onClick={handleSetFrequency}
          disabled={submitting}
        >
          {submitting ? 'Enregistrement...' : 'Définir'}
        </button>
      </div>
      <Toast type={toast.type} message={toast.message} />
    </div>
  );
}